<template>
    <div class="bg">
        <v-container>

          <div class="center nav">
            <v-icon style="position: absolute; left: 20px;color:#fff" @click="previous()"
              >mdi-arrow-left</v-icon>
              <img style="position: absolute; right: 20px;" src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FIcon.png?alt=media&token=129640ca-d490-4c4b-a387-49b379ace21e" alt="">

          </div>

           <!-- content -->
          <div :style="`height:${height}px;min-height: 70vh;border-radius: 20px;background:#fff;overflow: scroll;`">
            <v-container>
                <div style="display:flex;justify-content:center">
                    <v-avatar
                        color="indigo"
                        size="96"
                        style="position: absolute;
                        top: 70px;"
                        >
                        <span class="white--text text-h5">36</span>
                    </v-avatar>
                </div>
                <div>
                    <h2 style="color: var(--neutral-black, #0C092A);
                        text-align: center;

                        /* Heading / H3 */
                        font-family: Rubik;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 150%;
                        padding-top:20px;
                        padding-bottom:20px;">BeTask Consulting</h2>
                </div>
                <div style="border-radius: 20px;
                        background: #25388D;width: 327px;
                        height: 101px;
                        flex-shrink: 0;display:flex;">
                    <div class="col center">
                        <img class="center" src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FFrame.png?alt=media&token=31c4be80-de2f-4c93-b738-f4638791a59a" alt="">
                        <p style="padding:0;margin:0;padding-top: 0 !important;color: #fff;
                    ">10,000</p>
                        <p style="    font-size: 12px !important;padding:0;margin:0;padding-top: 0 !important;opacity: 0.5;color: #fff;">point</p>
                    </div>
                    <div class="col">
                        <img src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FGroup%20786.png?alt=media&token=3138874c-ece8-4b1d-8255-fc55aa84d987" alt="">
                        <p style="padding:0;margin:0;padding-top: 0 !important;color: #fff;
                        ">1</p>
                        <p style="    font-size: 12px !important;padding:0;margin:0;padding-top: 0 !important;opacity: 0.5;color: #fff;">Redeem</p>
                    </div>
                    <div class="col">
                        <img src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FGroup%20787.png?alt=media&token=9fc9239d-975e-4787-b07f-3b074dd09148" alt="">
                        <p style="padding:0;margin:0;padding-top: 0 !important;color: #fff;
                        ">4</p>
                        <p style="    font-size: 12px !important;padding:0;margin:0;padding-top: 0 !important;opacity: 0.5;color: #fff;">packet</p>
                    </div>
                </div>
                <div>
                    <h2 style="display: flex;
                        width: 263px;
                        height: 34px;
                        padding: 40px 0 20px 0;
                        align-items: center;
                        flex-shrink: 0;
                        margin: 0;">Promotion</h2>
                </div>
                <div>
                    <div class="image-h" @click="aa">
                        <div style="display:flex;justify-content:center;align-items:center;height:200px">
                            <img style="width:330px;"  src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FGroup%201841%20(1).png?alt=media&token=7f359f81-02ab-48c8-9b92-6dbf37f75899" alt="">
                        </div>
                    </div>
                </div>
                <div>
                    <h2 style="display: flex;
                        width: 263px;
                        height: 34px;
                        padding: 40px 0 20px 0;
                        align-items: center;
                        flex-shrink: 0;
                        margin: 0;">Redeem</h2>
                </div>
                <div style="display:flex;justify-content:space-between">
                    <div class="image" @click="aa">
                        <div style="display:flex;justify-content:center;align-items:center;height:100px">
                            <img style="width:80px;"  src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FGroup%201841.png?alt=media&token=77c5ac7e-10a6-4b5e-9440-f2c0fdcea64d" alt="">
                        </div>
                    </div>
                    <div class="image" @click="aa">
                        <div style="display:flex;justify-content:center;align-items:center;height:100px">
                            <img style="width:80px;"  src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/img%2FGroup%201841.png?alt=media&token=77c5ac7e-10a6-4b5e-9440-f2c0fdcea64d" alt="">
                        </div>
                    </div>
                </div></v-container>
          </div>
          <!-- content -->
        </v-container>

    </div>
</template>

<script>
// import axios from 'axios' // api
export default {
  name: 'LoyaltySystemConvertRate',

  data () {
    return {
      height: '',
      ProductExchangeRate: [],
      session: this.$session.getAll(),
      colors: [
        'indigo',
        'warning',
        'pink darken-2'
      ],
      slides: [
        'First',
        'Second',
        'Third'
      ]

    }
  },

  mounted () {
    this.checkDeviceHeight()
  },

  methods: {
    checkDeviceHeight () {
      // Get the viewport height
      const viewportHeight = window.innerHeight
      this.height = viewportHeight - 172
    },
    aa () {
      alert('aa')
    }

  }
}
</script>

<style scoped>
    .bg {
        background: #25388D;
        height: 100vh;
        width: 100%;
    }
    .nav {
  display: flex;
  align-items: center;
  height: 130px;
  /* background: red; */
}
/* .content {
    width: 100%;
    height: 600px;
    background: var(--neutral-white, #FFF);
    display: flex;
    justify-content: center;

} */
/* .footer {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 10px;
} */
.foot {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}

/* .footer div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
} */
p {
    color: #000;
    padding-top: 16px !important;
    padding-bottom: 0 !important;
}

/* .container1 {
  min-height: 70vh;
  background-color: #fff;
  border-radius: 20px;
} */

/* .box {
  max-height: 490px;
  background-color: blue;
} */
.container {
    padding:12px 15px 0 15px;
}
.btn-ok{
    border-radius: 20px;
    height: 56px !important;
    position: absolute;
    bottom: 8%;
   /*  padding: 0 16px; */
}
.v-btn--block {
    min-width: 85% !important;
}
/* .v-input--selection-controls {
    margin-top: 0;
    padding-top: 4px;
} */
.image {
    border-radius: 20px;
    background: var(--neutral-grey-5, #EEF3FC);
    width: 100%;
    height: 233px;
    flex-shrink: 0;
}
.carousel-height {
  height: 400px; /* Set the desired height here */
}
.image {
    border-radius: 20px;
    background: var(--neutral-grey-5, #EFEEFC);
    width: 47%;
    height: 100px;
    flex-shrink: 0;
}
.image-h {
    border-radius: 20px;
    background: var(--neutral-grey-5, #EEF3FC);
    width: 100%;
    height: 200px;
    flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/theme.vue